<template >
	<section class="popover" @mouseover="show" @mouseout="close">
		<div class="ui-popover" :class="[{ 'has-footer': hasFooter }, { 'has-header': hasHeader }]">
			<div class="ui-popover-header" v-if="hasHeader">
				{{ header }}
				<slot name="header"></slot>
			</div>

			<div class="ui-popover-content" v-if="hasContent" :class="`ui-popover-content-${position}`" :style="[ paddingSetContent, openPopover]" ref="uiPopoverContent" hidden>
				{{ content }}
				<slot name="content"></slot>
			</div>

			<div class="ui-popover-footer" v-if="hasFooter">	
				{{ footer }}
				<slot name="footer"></slot>
			</div>

			<div class="ui-popover-arrow"></div>
		</div>

		<button class="ui-popover-reference" slot="reference" ref="reference">
			<slot name="target"></slot>
		</button>
	</section>
</template>

<script>

	export default {
		name: 'ui-popover-v2',

		props: {
			content: {
				type: String,
				default: '',
			},

			header: {
				type: String,
				default: '',
			},

			footer: {
				type: String,
				default: '',
			},

			placement: {
				type: String,
				default: 'top',
			},

			trigger: {
				type: String,
				default: 'click',
			},

			width: {
				type: Number,
			},

			appendToBody: {
				type: Boolean,
				default: true,
			},

			disabled: {
				type: Boolean,
				default: false,
			},
			paddingContent : {
				type: String,
				default: '20px',
			}
		},

		data() {
			return {
				position: this.placement,
				paddingSetContent: {'padding': this.paddingContent},
				openPopover: {},
			}
		},


		computed: {
			hasContent() {
				return this.$slots.content || this.content ? true : false
			},

			hasHeader() {
				return this.$slots.header || this.header ? true : false
			},

			hasFooter() {
				return this.$slots.footer || this.footer ? true : false
			},
		},

		methods: {

			setPosition(rect, balao, local) {
				//adiciona o style para o balão como deve ser aberto
				switch (rect) {
					case 'top':
						this.openPopover = {'top': `${local.y -  60}px`, 'left': `${local.x - (balao.width / 3)}px`}
						break;
					case 'left':
						this.openPopover = {'top': `${local.y - 20}px`, 'left': `${local.x - (balao.width + 10)}px`}
						break
					case 'right':
						this.openPopover = {'top': `${local.y - 20}px`, 'left': `${local.x + (local.width)}px`}
					break
					case 'bottom':
						this.openPopover = {'top': `${local.y + local.height + 10}px`, 'left': `${local.x - (balao.width / 3)}px`}
					break
					default:
						this.openPopover = {'top': `${local.y -  60}px`, 'left': `${local.x - (balao.width / 3)}px`}
						break;
				}

			},

			show(e) {
				//tamanho total da tela
				const widthWindow = window.innerWidth
				const content = this.$refs.uiPopoverContent
				const local = this.$refs.reference.getBoundingClientRect()

				// verifica a posição do mouse e da div
				if (local.x <= 100) this.position = 'right'
				else if (local.x > 100 &&  widthWindow - e.clientX <= 200 ) this.position = 'left'
				else {
					if (e.clientY < 100) this.position = 'bottom'
					else this.position = this.placement	
				}

				// remove o atributo hidden da div
				content.removeAttribute('hidden')

				// verifica parametro da div
				const balao = this.$refs.uiPopoverContent.getBoundingClientRect()

				this.setPosition(this.position, balao, local)
			},

			close() {
				//adiciona o hidden para sumir o balão
				const content = this.$refs.uiPopoverContent
				content.setAttribute('hidden', '')
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>